
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class HeadColumn extends Vue {
  @Prop(Object) row!: any
  @Prop(Object) data!: any

  get iconClass() {
    const classes = []
    if (this.data && this.data.sortBy === this.row.key) classes.push('active')
    if (this.row.orderable) classes.push('cursor')
    return classes
  }

  sort() {
    if (!this.row.orderable) return
    let orderBy = null
    if (!this.data || this.data.sortBy !== this.row.key) orderBy = 'asc'
    if (this.data && this.data.sortBy === this.row.key && this.data.orderBy)
      orderBy = this.data.orderBy === 'asc' ? 'desc' : 'asc'
    this.$emit('sort', {
      sortBy: this.row.key,
      orderBy
    })
  }
}
